/**
 * Soglie di cloro e pH, in un posto solo.
 *
 * Il giudizio "fuori soglia" serve a due padroni: il modulo che avvisa mentre si scrive e la
 * lettura dello storico. Se lo calcolassero ognuno per conto suo, prima o poi direbbero cose
 * diverse sullo stesso numero.
 *
 * Regola dichiarata: un valore **fuori soglia non blocca il salvataggio**. Chi misura ha
 * l'acqua davanti, l'app no; e l'avviso non sostituisce le procedure di sicurezza dell'azienda.
 */
export type PoolRange = { min: number; max: number };

export type ReadingVerdict = "dentro" | "sotto" | "sopra" | "non-misurato";

export function verdictFor(value: number | null | undefined, range: PoolRange): ReadingVerdict {
  if (value == null || Number.isNaN(value)) return "non-misurato";
  if (value < range.min) return "sotto";
  if (value > range.max) return "sopra";
  return "dentro";
}

export function isOutOfRange(verdict: ReadingVerdict) {
  return verdict === "sotto" || verdict === "sopra";
}

/** L'avviso scritto come lo direbbe una persona, con il numero e l'intervallo giusto. */
export function rangeWarning(label: string, value: number | null | undefined, range: PoolRange, unit = ""): string | null {
  const verdict = verdictFor(value, range);
  if (!isOutOfRange(verdict)) return null;
  const direzione = verdict === "sotto" ? "sotto" : "sopra";
  return `${label} ${value}${unit} e ${direzione} l'intervallo previsto, da ${range.min}${unit} a ${range.max}${unit}. Puoi salvare lo stesso.`;
}
